// For storing an ES6 Map in localStorage with JSON.stringify
export function replacer(key: string, value: unknown): unknown {
  if (value instanceof Map) {
    return {
      dataType: 'Map',
      value: Array.from(value.entries()), // or with spread: value: [...value]
    }
  } else {
    return value
  }
}
// For retrieving an ES6 Map from localStorage with JSON.parse
export function reviver(key: string, value: unknown): unknown {
  if (typeof value === 'object' && value !== null) {
    const obj = value as { dataType?: string; value?: [unknown, unknown][] }
    if (obj.dataType === 'Map') {
      return new Map(obj.value)
    }
  }
  return value
}
